export const LOAD_LOCATION = 'LOAD_LOCATION'
export const ADD_SCROLL_STOCK_DATA = 'ADD_SCROLL_STOCK_DATA'
export const ADD_NEXT_STOCK = 'ADD_NEXT_STOCK'


